import React from "react";
import styles from "./chat-time.module.less";
import { ChatTimeProps } from "../../types/chat-msg-types";

const ChatTime: React.FC<ChatTimeProps> = (props: ChatTimeProps) => {
    return(
        <div className={styles.ChatTimeLess}>
            {
                props.date ? new Date(props.date).toLocaleTimeString("en-SG", {
                    year: "2-digit",
                    month: "short",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit"
                }).toString() : new Date().toLocaleTimeString("en-SG", {
                    year: "2-digit",
                    month: "short",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit"
                }).toString()
            }
        </div>
    )
}

export default ChatTime;